export const tuple = <T extends unknown[]>(...args: T): T => args;
